import { jsx as _jsx } from "react/jsx-runtime";
export const DealerLocatorOptions = ({ children }) => (_jsx("div", { className: "d-flex align-items-start justify-content-between my-3", children: children }));
